var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 341.337
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 127.994,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 42.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 213.331,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 42.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 298.657,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 42.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 383.994,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 42.663
  })), /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    style: {
      fill: "#2E52B2"
    },
    width: 256,
    height: 183.797
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "99.822,160.624 95.699,173.308 82.363,173.308 93.154,181.143 89.031,193.826  99.822,185.991 110.606,193.826 106.484,181.143 117.275,173.308 103.938,173.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "103.938,219.08 99.822,206.397 95.699,219.08 82.363,219.08 93.154,226.916 89.031,239.599  99.822,231.763 110.606,239.599 106.484,226.916 117.275,219.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "47.577,219.08 43.46,206.397 39.337,219.08 26.001,219.08 36.792,226.916 32.669,239.599  43.46,231.763 54.245,239.599 50.123,226.916 60.912,219.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "43.46,160.624 39.337,173.308 26.001,173.308 36.792,181.143 32.669,193.826 43.46,185.991  54.245,193.826 50.123,181.143 60.912,173.308 47.577,173.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "99.822,114.85 95.699,127.535 82.363,127.535 93.154,135.371 89.031,148.054  99.822,140.218 110.606,148.054 106.484,135.371 117.275,127.535 103.938,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "43.46,114.85 39.337,127.535 26.001,127.535 36.792,135.371 32.669,148.054 43.46,140.218  54.245,148.054 50.123,135.371 60.912,127.535 47.577,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "156.183,160.624 152.061,173.308 138.725,173.308 149.515,181.143 145.394,193.826  156.183,185.991 166.969,193.826 162.846,181.143 173.637,173.308 160.301,173.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "160.301,219.08 156.183,206.397 152.061,219.08 138.725,219.08 149.515,226.916  145.394,239.599 156.183,231.763 166.969,239.599 162.846,226.916 173.637,219.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "216.663,219.08 212.546,206.397 208.423,219.08 195.088,219.08 205.877,226.916  201.755,239.599 212.546,231.763 223.331,239.599 219.208,226.916 229.999,219.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "212.546,160.624 208.423,173.308 195.088,173.308 205.877,181.143 201.755,193.826  212.546,185.991 223.331,193.826 219.208,181.143 229.999,173.308 216.663,173.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "156.183,114.85 152.061,127.535 138.725,127.535 149.515,135.371 145.394,148.054  156.183,140.218 166.969,148.054 162.846,135.371 173.637,127.535 160.301,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "212.546,114.85 208.423,127.535 195.088,127.535 205.877,135.371 201.755,148.054  212.546,140.218 223.331,148.054 219.208,135.371 229.999,127.535 216.663,127.535  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.59c09ec3.svg";
export { ForwardRef as ReactComponent };